import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import { LayerBottom, Button } from 'components'
import travelImg from 'images/tmp_travel_image.png'
import styles from './index.module.css'

const TravelSelect = () => {

	const App = useApp()
	const [showLayer, setShowLayer] = useState(false)
	const [showTheme, setShowTheme] = useState(false)

	const openLayer = () => {
		setShowLayer(true)
	}

	const closeLayer = () => {
		setShowLayer(false)
	}

	const openTheme = () => {
		setShowTheme(true)
	}

	const closeTheme = () => {
		setShowTheme(false)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="padding">
				<div className="flex-align_center">
					<div className={`${styles["select-area"]} ${styles.box}`} onClick={openLayer}>
						<span>서울 전체</span>
						<i className="icon" />
					</div>
					<div className={`${styles["select-area"]} ${styles.box} ml_10`} onClick={openTheme}>
						<span>관광지 외 2</span>
						<i className="icon" />
					</div>
				</div>

				<ul className={`${styles["travel-view"]} mt_30`}>
					<li>
						<div>
							<div className="img-box" style={{ height: "13rem" }}>
								<img src={travelImg} alt="" />
							</div>
							<div className={styles.txt}>
								<i className="tag tag-box tag-green-bg">관광지</i>
								<div className={styles.title}>갈산근린공원</div>
								<span>#공원</span>
							</div>
						</div>
						<div>
							<div className="img-box" style={{ height: "13rem" }}>
								<img src={travelImg} alt="" />
							</div>
							<div className={styles.txt}>
								<i className="tag tag-box tag-yellow">문화시설</i>
								<div className={styles.title}>감로암(서울)</div>
								<span>#소분류</span>
							</div>
						</div>
					</li>
					<li>
						<div>
							<div className="img-box" style={{ height: "13rem" }}>
								<img src={travelImg} alt="" />
							</div>
							<div className={styles.txt}>
								<i className="tag tag-box tag-pink">축제・행사</i>
								<div className={styles.title}>갈산근린공원</div>
								<span>#공원</span>
							</div>
						</div>
						<div>
							<div className="img-box" style={{ height: "13rem" }}>
								<img src={travelImg} alt="" />
							</div>
							<div className={styles.txt}>
								<i className="tag tag-box tag-purple">레포츠</i>
								<div className={styles.title}>감로암(서울)</div>
								<span>#소분류</span>
							</div>
						</div>
					</li>
					<li>
						<div>
							<div className="img-box" style={{ height: "13rem" }}>
								<img src={travelImg} alt="" />
							</div>
							<div className={styles.txt}>
								<i className="tag tag-box tag-blue">쇼핑</i>
								<div className={styles.title}>갈산근린공원</div>
								<span>#공원</span>
							</div>
						</div>
						<div>
							<div className="img-box" style={{ height: "13rem" }}>
								<img src={travelImg} alt="" />
							</div>
							<div className={styles.txt}>
								<i className="tag tag-box tag-sky">음식</i>
								<div className={styles.title}>감로암(서울)</div>
								<span>#소분류</span>
							</div>
						</div>
					</li>
					<li>
						<div>
							<div className="img-box" style={{ height: "13rem" }}>
								<img src={travelImg} alt="" />
							</div>
							<div className={styles.txt}>
								<i className="tag tag-box tag-orange">숙박</i>
								<div className={styles.title}>갈산근린공원</div>
								<span>#공원</span>
							</div>
						</div>
						<div>
							<div className="img-box" style={{ height: "13rem" }}>
								<img src={travelImg} alt="" />
							</div>
							<div className={styles.txt}>
								<i className="tag tag-box tag-red">여행코스</i>
								<div className={styles.title}>감로암(서울)</div>
								<span>#소분류</span>
							</div>
						</div>
					</li>
				</ul>

				<div className={`${styles["guide-bottom"]} mt_50`}>한국관광공사에서 받아오는 정보입니다.</div>
			</div>

			<SelectLayer show={showLayer} closeLayer={closeLayer} />
			<ThemeLayer show={showTheme} closeLayer={closeTheme} />
		</div>
	)
}

const ThemeLayer = ({ show, closeLayer }) => {
	return (
		<LayerBottom title="기관 선택" show={show} closeLayer={closeLayer} outside={
			<Button className="btn btn--big btn-layer" onClick={closeLayer}>확인</Button>
		}>
			<ul className="opt-menu">
				<li className="active">관광지</li>
				<li>문화시설</li>
				<li>숙박</li>
				<li>여행코스</li>
				<li>축제・행사</li>
				<li className="active">레포츠</li>
				<li className="active">쇼핑</li>
				<li>음식</li>
			</ul>
		</LayerBottom>
	)
}

const SelectLayer = ({ show, closeLayer }) => {

	const [menuOpen, setMenuOpen] = useState(0)

	return (
		<LayerBottom title="지역 선택" show={show} closeLayer={closeLayer} closeButton={false} outside={
			<Button className="btn btn--big btn-layer" onClick={closeLayer}>확인</Button>
		}>
			<ul className={`${styles["area-list"]} accordion-list`}>
				<li className={menuOpen === 0 ? "active" : ""} onClick={() => setMenuOpen(0)}>
					<div className="flex-justify_between align_center">
						<p className="bold">전국</p>
						<i className="icon icon_arrow_sm bottom" />
					</div>
					<div className="menu-open mt_20">
						<ul className="menu-select">
							<li className="on">국내전체</li>
						</ul>
					</div>
				</li>
				<li className={menuOpen === 1 ? "active" : ""} onClick={() => setMenuOpen(1)}>
					<div className="flex-justify_between align_center">
						<p className="bold">서울</p>
						<i className="icon icon_arrow_sm bottom" />
					</div>
					<div className="menu-open mt_20">
						<ul className="menu-select">
							<li className="on">서울전체</li>
							<li>강남구</li>
							<li>강동구</li>
							<li>강부구</li>
							<li>강서구</li>
							<li>관악구</li>
							<li>광진구</li>
							<li>구로구</li>
							<li>금천구</li>
							<li>노원구</li>
							<li>도봉구</li>
							<li>동대문구</li>
							<li>동작구</li>
							<li>마포구</li>
							<li>서대문구</li>
							<li>서초구</li>
							<li>성동구</li>
							<li>성북구</li>
							<li>송파구</li>
							<li>양천구</li>
							<li>영등포구</li>
							<li>용산구</li>
							<li>은평구</li>
							<li>종로구</li>
							<li>중구</li>
							<li>중랑구</li>
						</ul>
					</div>
				</li>
				<li className={menuOpen === 2 ? "active" : ""} onClick={() => setMenuOpen(2)}>
					<div className="flex-justify_between align_center">
						<p className="bold">인천</p>
						<i className="icon icon_arrow_sm bottom" />
					</div>
					<div className="menu-open mt_20">
						<ul className="menu-select">
							<li className="on">중구</li>
							<li>동구</li>
							<li>미추홀구</li>
							<li>연수구</li>
						</ul>
					</div>
				</li>
				<li className={menuOpen === 3 ? "active" : ""} onClick={() => setMenuOpen(3)}>
					<div className="flex-justify_between align_center">
						<p className="bold">대전</p>
						<i className="icon icon_arrow_sm bottom" />
					</div>
					<div className="menu-open mt_20">
						<ul className="menu-select">
							<li className="on">대덕구</li>
							<li>서구</li>
						</ul>
					</div>
				</li>
			</ul>
		</LayerBottom>
	)
}

export default TravelSelect